import { Table, TableProps } from 'antd'
import styles from './Table.module.less'
import EmptyIcon from '../../../assets/icons/empty-icon.svg?react'
import { ConfigProvider } from 'antd'
import Icon from '@ant-design/icons/lib/components/Icon'
import { AnyObject } from 'antd/lib/_util/type'
import { DataTestId } from 'src/constants/ui.constants'

export type TableCompProps<RecordType = AnyObject> = {
    loading?: boolean
    emptyIconText?: string
    rowSelection?: TableProps<RecordType>['rowSelection']
    columns: TableProps<RecordType>['columns']
    dataSource: TableProps<RecordType>['dataSource']
    size?: TableProps<RecordType>['size']
    pagination?: TableProps<RecordType>['pagination']
    scroll?: TableProps<RecordType>['scroll']
    className?: string
    emptyTableHeight?: string
}

function TableComp<RecordType>(props: TableCompProps<RecordType>) {
    return (
        <div className={styles['table-parent']} data-testid={DataTestId.Table}>
            <ConfigProvider
                renderEmpty={() => (
                    <div className={styles['empty']} style={{ height: props.emptyTableHeight }}>
                        <Icon className={styles['empty-icon']} component={EmptyIcon} />
                        <span className={styles['empty-text']}>{props.emptyIconText}</span>
                    </div>
                )}
            >
                <Table<RecordType>
                    {...props}
                    className={[props.className, styles['table-body']].join(' ')}
                />
            </ConfigProvider>
        </div>
    )
}

export default TableComp
